export const FETCH_DOWNLOAD_DOCUMENTS_REQUEST = 'FETCH_DOWNLOAD_DOCUMENTS_REQUEST'
export const FETCH_DOWNLOAD_DOCUMENTS_SUCCESS = 'FETCH_DOWNLOAD_DOCUMENTS_SUCCESS'
export const FETCH_DOWNLOAD_DOCUMENTS_FALUIRE = 'FETCH_DOWNLOAD_DOCUMENTS_FALUIRE'
